/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface BusinessObjectFormatExternalInterfaceKey { 
    /**
     * The namespace
     */
    namespace: string;
    /**
     * The business object definition name
     */
    businessObjectDefinitionName: string;
    /**
     * The business object format usage
     */
    businessObjectFormatUsage: string;
    /**
     * The business object format file type
     */
    businessObjectFormatFileType: string;
    /**
     * The external interface name
     */
    externalInterfaceName: string;
}
